<template>
  <div>
    <div class="info-card">
      <div class="info-card__info">
        <p class="info-card__title">
          {{ title }}
        </p>
        <p class="info-card__description">
          {{ description }}
        </p>
      </div>
      <div class="info-card__icon">
        <span><font-awesome-icon
          :icon="['fal', icon]"
          size="3x"
          :class="'icon--' + iconColor"
        /></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoCard',
  props: {
    title: [String, Number],
    description: String,
    icon: String,
    iconColor: String
  }
}
</script>

<style lang="scss" scoped>
.info-card {
  border: 1px solid #ccc;
  padding: 2rem 2.5rem;
  margin-bottom: 2.8rem;
  display: flex;
  justify-content: space-between;
  min-height: 104px;

  .info-card__info {
    text-decoration: none;
    font-size: 1.6rem;

    .info-card__title {
      color: #4257A0;
      font-size: 2.4rem;
      margin: 0;
    }

    .info-card__description {
      color: #999;
      margin: 0;
    }
  }

  .info-card__icon {
    align-self: center;
    .icon--success {
      color: $success;
    }
    .icon--warning {
      color: $warning;
    }
    .icon--danger {
      color: $danger;
    }
    .icon--gray {
      color: #999;
    }
  }
}
</style>
